import { categories } from '@/mocks/articles';

const CategorySection = () => {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">Shop by Category</h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Browse all product categories and use your <strong>joyagoo coupon code</strong> at checkout to save on every order.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white border border-gray-100 rounded-2xl overflow-hidden hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full h-36 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} - JoyaGoo Coupon Deals`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-3 text-center">
                <p className="font-semibold text-gray-800 text-sm mb-0.5">{cat.name}</p>
                <p className="text-xs text-orange-500 font-medium">View Products →</p>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://repsw2c.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-orange-500 text-white font-bold rounded-xl hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-store-2-line"></i>
            Browse All Products – Use joyagoo coupon
          </a>
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
